import { lazy, Suspense } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Web3Provider } from './contexts/Web3Context';
import { ToastProvider } from './components/ui';
import Home from './pages/Home';
import { Layout, Card, CyberGrid, ScrollToTop } from './components';

const WalletLink = lazy(() => import('./pages/WalletLink'));
const Subscribe = lazy(() => import('./pages/Subscribe'));
const MerchantSetup = lazy(() => import('./pages/MerchantSetup'));
const CreateSubscription = lazy(() => import('./pages/CreateSubscription'));
const ExportMembers = lazy(() => import('./pages/ExportMembers'));

const NotFound = () => (
  <Layout>
    <div className="relative overflow-hidden min-h-[calc(100vh-88px)] flex items-center justify-center p-4">
      <CyberGrid />
      <div className="relative z-10 max-w-md w-full">
        <Card className="text-center">
          <div className="text-6xl mb-4 font-display text-white/20">404</div>
          <h2 className="text-xl font-bold font-display text-white mb-2">Page Not Found</h2>
          <p className="text-text-muted mb-6">
            The page you're looking for doesn't exist or has been moved.
          </p>
          <a
            href="/"
            className="inline-flex items-center px-6 py-2.5 rounded-full bg-accent text-slate-950 font-medium font-display hover:bg-accent-hover shadow-glow transition-all"
          >
            Go Home
          </a>
        </Card>
      </div>
    </div>
  </Layout>
);

function App() {
  return (
    <Web3Provider>
      <ToastProvider>
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/link" element={<Suspense fallback={<div className="min-h-screen" />}><WalletLink /></Suspense>} />
            <Route path="/s/:token" element={<Suspense fallback={<div className="min-h-screen" />}><Subscribe /></Suspense>} />
            <Route path="/setup" element={<Suspense fallback={<div className="min-h-screen" />}><MerchantSetup /></Suspense>} />
            <Route path="/create" element={<Suspense fallback={<div className="min-h-screen" />}><CreateSubscription /></Suspense>} />
            <Route path="/export" element={<Suspense fallback={<div className="min-h-screen" />}><ExportMembers /></Suspense>} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </BrowserRouter>
      </ToastProvider>
    </Web3Provider>
  );
}

export default App;
